import { useState } from 'react';

const STORAGE_KEY = 'mindmap.propertiesPanel.collapsed';

// Storage can be missing or blocked (private windows, previews); sections then just start open.
const readCollapsed = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return new Set(Array.isArray(saved) ? saved : []);
    } catch (error) {
        return new Set();
    }
};

const saveCollapsed = (collapsed) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([...collapsed]));
    } catch (error) {
        // Not remembered this time; the section still opens and closes.
    }
};

/** Whether the section `id` is open, remembered in this browser across tabs and panel openings. */
export const useSectionOpen = (id) => {
    const [isOpen, setIsOpen] = useState(() => !readCollapsed().has(id));

    const toggle = () => {
        const next = !isOpen;
        const collapsed = readCollapsed();
        if (next) collapsed.delete(id);
        else collapsed.add(id);
        saveCollapsed(collapsed);
        setIsOpen(next);
    };

    return [isOpen, toggle];
};
